import { action, observable, set } from "mobx";
import moment from "moment";
import Model from "~/models/Model";

class UiMeet3dLink extends Model {
  /**
   * @property {number|null}
   */
  @observable uiMeet3dLinkId = null;

  /**
   * @property {number|null}
   */
  @observable tourId = null;

  /**
   * @property {string|null}
   */
  @observable shortUrlId = null;

  /**
   * @property {string|null}
   */
  @observable roomId = null;

  /**
   * @property {string|null}
   */
  @observable role = null;

  /**
   * @property {string|null}
   */
  @observable name = null;

  /**
   * @property {string|null}
   */
  @observable email = null;

  /**
   * @property {string|null}
   */
  @observable shortUrl = null;

  /**
   * @property {string|null}
   */
  @observable photoUrl = null;

  /**
   * @property {number|null}
   */
  @observable photoWidth = null;

  /**
   * @property {number|null}
   */
  @observable photoHeight = null;

  /**
   * @property {string|null}
   */
  @observable photoPathWeb = null;

  /**
   * @property {string|null}
   */
  @observable logoUrl = null;

  /**
   * @property {number|null}
   */
  @observable logoWidth = null;

  /**
   * @property {number|null}
   */
  @observable logoHeight = null;

  /**
   * @property {string|null}
   */
  @observable logoPathWeb = null;

  /**
   * @property {boolean|null}
   */
  @observable usePhotos = true;

  /**
   * @property {boolean|null}
   */
  @observable isGuidedTourMode = false;

  /**
   * @property {number|null}
   */
  @observable activationDts = null;

  /**
   * @property {number|null}
   */
  @observable expirationDts = null;

  /**
   * @property {number|null}
   */
  @observable creationDts = null;

  /**
   * @property {number|null}
   */
  @observable modificationDts = null;

  @action
  setData(data) {
    const { activationDts, expirationDts, creationDts, modificationDts, ...rest } = data;
    set(this, rest);

    this.activationDts = activationDts ? moment.unix(activationDts) : null;
    this.expirationDts = expirationDts ? moment.unix(expirationDts) : null;
    this.creationDts = creationDts ? moment.unix(creationDts) : null;
    this.modificationDts = modificationDts ? moment.unix(modificationDts) : null;
  }
}

export default UiMeet3dLink;
